const environment = (function() {
    switch (process.env.FILER_ROOT) {
        case 'https://filer.test.thefoodassembly.com':
            return 'sandbox';
        case 'https://filer.thefoodassembly.com':
            return 'production';
        default:
            return 'dev-local';
    }
})();

export default environment;
